module.exports = __webpack_public_path__ + "static/media/ico_simulation_lip_cornerlift.88276597.png";